export const FETCH_TEACHER_PENDING_REQUEST = "FETCH_TEACHER_PENDING_REQUEST"
export const TEACHER_UPCOMING_SESSION = "TEACHER_UPCOMING_SESSION"
export const TEACHER_PAST_SESSION = "TEACHER_PAST_SESSION"
export const TEACHER_DECLINE = "TEACHER_DECLINE"